import { ChangeDetectorRef, Component, Input, OnChanges, OnInit } from '@angular/core';
import { PrinterService } from 'src/app/provider/printer.service';
import { PrinterSetup } from '../../models/printer.model';
import { TokenFormModel } from '../../pages/auth/models/tokenform.model';

@Component({
  selector: 'kt-printer-setup',
  templateUrl: './printer-setup.component.html',
  styleUrls: ['./printer-setup.component.scss']
})
export class PrinterSetupComponent implements OnInit, OnChanges {

  @Input() ID: number;


  tokenForm: TokenFormModel = JSON.parse(localStorage.getItem('token_form'));

  // Printer variables
  selectedTemplate: string = null;
  selectedPrinterIndex: number = null;


  constructor(
    public printerServ: PrinterService,
    private changeDetect: ChangeDetectorRef
  ) {

  }

  ngOnInit() {

  }

  async addPrinter() {
    const PRINTER = this.printerServ.printers[this.selectedPrinterIndex];
    const SETUP = new PrinterSetup();

    SETUP.printer_id = PRINTER.id;
    SETUP.table_name = 'menu-item';
    SETUP.table_record_id = this.ID;
    SETUP.hotel_id = this.tokenForm.app_hotel_id;
    SETUP.report_name = this.selectedTemplate;

    try {
      await this.printerServ.postSetup(SETUP);
      await this.printerServ.getSetups();
      this.selectedPrinterIndex = null;
      this.selectedTemplate = null;
      this.changeDetect.detectChanges();
    } catch { }
  }

  async deletePrinterSetup(setupId: number) {
    await this.printerServ.deleteSetup(setupId);
    this.refresh();
  }

  refresh() {
    this.changeDetect.detectChanges();
  }

  async ngOnChanges(changes: { [propKey: string]: any }) {
    this.ID = changes.ID.currentValue;
    await this.printerServ.getPrinters();
    await this.printerServ.getSetups();
    this.changeDetect.detectChanges();
  }

}
